import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VuexPersist from "vuex-persist";
import * as msal from "@azure/msal-browser";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "ChurchWebAppSession",
  storage: window.sessionStorage
});

export default new Vuex.Store({
  state: {
    basket: [],
    isCoventryAdmin: false,
    isLeicesterAdmin: false,
    intent: {
      amount: null,
      id: "",
      clientSecret: ""
    },
    showPaymentUI: false,
    userAuthenticated: false,
    userFullName: "",
    userInitials: "",
    username: ""
  },
  mutations: {
    addToBasket(state, item) {
      state.basket.push(item);
    },
    removeFromBasket(state, item) {
      state.basket.splice(state.basket.indexOf(item), 1);
    },
    resetBasket(state) {
      state.basket = [];
      Object.assign(state.intent, { amount: null, id: "", clientSecret: "" });
    },
    showPayment(state, status) {
      state.showPaymentUI = status;
    },
    setPaymentIntent(state, intent) {
      state.intent = intent;
      state.showPaymentUI = true;
    },
    setUserRoles(state, roles) {
      state.roles = roles;
    },
    setUserInitials(state, userInitials) {
      state.userInitials = userInitials;
    },
    setUserFullName(state, userFullName) {
      state.userFullName = userFullName;
    },
    setUsername(state, username) {
      state.username = username;
    },
    setUserIsAuthenticated: function(state, status) {
      state.userAuthenticated = status;
    },
    setCoventryAdminStatus(state, status) {
      state.isCoventryAdmin = status;
    },
    setLeicesterAdminStatus(state, status) {
      state.isLeicesterAdmin = status;
    }
  },
  getters: {
    basketTotal(state) {
      return parseFloat(
        state.basket.reduce((a, b) => a + b.res_Price, 0)
      ).toFixed(2);
    },
    basketCount(state) {
      return state.basket.length;
    },
    getBasket(state) {
      return state.basket;
    },
    getIntent(state) {
      return state.intent;
    },
    getUserFullName(state) {
      return state.userFullName;
    },
    getUserInitials(state) {
      return state.userInitials;
    },
    userIsAuthenticated(state) {
      return state.userAuthenticated;
    },
    getUsername(state) {
      return state.username;
    },
    isCoventryAdmin(state) {
      return state.isCoventryAdmin;
    },
    isLeicesterAdmin(state) {
      return state.isLeicesterAdmin;
    }
  },
  actions: {
    async handleAuthenticationRedirect(context, { vm, response }) {
      // console.log("Hello1");
      // console.log(response);
      if (response) {
        //debugger;
        context.commit("setUsername", response.account.username);
        context.commit("setUserIsAuthenticated", true);
        context.commit("setUserFullName", response.idTokenClaims.name);
        await context.dispatch("fetchUserRoles", vm);
      } else {
        const currentAccounts = vm.$msalInstance.getAllAccounts();
        if (currentAccounts === null) {
          return;
        } else if (currentAccounts.length > 1) {
          // Add choose account code here
          console.warn("Multiple accounts detected.");
        } else if (currentAccounts.length === 1) {
          //username = currentAccounts[0].username;
          //showWelcomeMessage(currentAccounts[0]);
        }
      }
    },
    async signIn(context, { vm }) {
      vm.$msalInstance.loginRedirect(vm.$loginRequest);
    },
    signOut(context, { vm }) {
      context.commit("setUserFullName", null);
      context.commit("setUserIsAuthenticated", false);
      context.commit("setCoventryAdminStatus", false);
      context.commit("setLeicesterAdminStatus", false);
      const logoutRequest = {
        account: vm.$msalInstance.getAccountByUsername(
          context.getters.getUsername
        )
      };
      vm.$msalInstance.logout(logoutRequest);
    },
    async getToken(context, { vm }) {
      vm.$tokenRequest.account = vm.$msalInstance.getAccountByUsername(
        context.getters.getUsername
      );
      //debugger;
      try {
        const { accessToken } = await vm.$msalInstance.acquireTokenSilent(
          vm.$tokenRequest
        );
        return accessToken;
      } catch (error) {
        if (error instanceof msal.InteractionRequiredAuthError) {
          const { accessToken } = await vm.$msalInstance.acquireTokenRedirect(
            vm.$tokenRequest
          );
          return accessToken;
        }
      }
    },
    async getTokenGraph(context, vm) {
      vm.$loginRequest.account = vm.$msalInstance.getAccountByUsername(
        context.getters.getUsername
      );
      try {
        const { accessToken } = await vm.$msalInstance.acquireTokenSilent(
          vm.$loginRequest
        );
        return accessToken;
      } catch (error) {
        if (error instanceof msal.InteractionRequiredAuthError) {
          const { accessToken } = await vm.$msalInstance.acquireTokenRedirect(
            vm.$loginRequest
          );
          return accessToken;
        }
      }
    },
    async fetchUserRoles(context, vm) {
      const token = await context.dispatch("getTokenGraph", vm);
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let roles = null;
      ({
        data: { value: roles }
      } = await axios.get(vm.$graphConfig.graphGroupsEndpoint, config));

      context.commit("setCoventryAdminStatus", false);
      context.commit("setLeicesterAdminStatus", false);

      if (roles.find(p => p.displayName === "coventry")) {
        context.commit("setCoventryAdminStatus", true);
      } else if (roles.find(p => p.displayName === "leicester")) {
        context.commit("setLeicesterAdminStatus", true);
      }
    }
  },

  plugins: [vuexPersist.plugin]
});
